<section class="h-full flex-col">
  <nav
    ngbNav
    #nav="ngbNav"
    class="nav-tabs border-bottom"
    [destroyOnHide]="false"
  >
    <!-- ^phonebook -->
    <ng-container ngbNavItem>
      <a
        ngbNavLink
        class="!tw-flex-center"
        [class]="isWhiteMessagePhonebook ? 'tw-w-full' : 'tw-w-1/2'"
      >
        <div class="tw-w-full !tw-flex-between">
          <div class="tw-flex-center">
            <i
              class="mdi mdi-account-multiple-outline text-blue tw-mr-1 tw-text-3xl"
            ></i>
            <span class="tw-mt-1 tw-mr-2 text-dark">{{
              "common.phonebook" | translate
            }}</span>
            <i
              (click)="onRefresh()"
              class="mdi mdi-refresh text-gray tw-mx-2 tw-text-2xl tw-opacity-70 hover:tw-opacity-95 tw-pt-2"
            ></i>
          </div>
          <div
            class="tw-flex-center cursor-pointer"
            (click)="openSelectedPhonebooksDialog(phonebookRecipients)"
          >
            <i
              *ngIf="phonebookSelectedIds?.length"
              [matTooltip]="'common.showDetails' | translate"
              class="mdi mdi-24px mdi-format-list-bulleted tw-opacity-60 mx-1"
            ></i>
            <span
              [class]="
                phonebookSelectedIds?.length ? 'badge-primary' : 'badge-light'
              "
              class="badge mx-2 border dir-ltr tw-text-[13px] text-wrap"
            >
              {{ (phonebookRecipients | removeEmptyContacts)?.length }}
            </span>
          </div>
        </div>
      </a>
      <ng-template ngbNavContent>
        <div class="send-sms-phonebook tw-w-full !tw-min-h-[400px]">
          <!-- [phonebookRecipients]="recipients" -->
          <phonebook-list
            class="tw-w-full"
            [privateNumber]="privateNumber"
            [isFixedHeight]="true"
            [isShowParentBtn]="isShowParentBtn"
            [isWhiteMessagePhonebook]="isWhiteMessagePhonebook"
            [isShowInputs]="isShowInputs"
            [justCurrentOrganization]="justCurrentOrganization"
            (phonebookRecipientsChange)="getRecipients($event)"
            (selectedPhonebooksChange)="getPhonebookIds($event)"
          >
          </phonebook-list>
        </div>
      </ng-template>
    </ng-container>

    <!--* pro search -->
    <ng-container ngbNavItem *ngIf="!isWhiteMessagePhonebook">
      <a ngbNavLink class="tw-w-1/2 !tw-flex-center">
        <div class="tw-w-full !tw-flex-between">
          <div class="tw-flex-center">
            <i
              class="mdi mdi-text-search-variant text-info tw-mr-1 tw-text-3xl"
            ></i>
            <span class="tw-mt-1 tw-mr-2 text-dark">{{
              "common.advanceSearch" | translate
            }}</span>
          </div>
          <div
            class="tw-flex-center"
            (click)="openSelectedPhonebooksDialog(searchedRecipients)"
          >
            <i
              *ngIf="searchedPhonebookIds?.length"
              [matTooltip]="'common.showDetails' | translate"
              class="mdi mdi-24px mdi-format-list-bulleted tw-opacity-60 mx-1"
            ></i>
            <span
              [class]="
                searchedPhonebookIds?.length ? 'badge-info' : 'badge-light'
              "
              class="badge mx-2 border dir-ltr tw-text-[13px] text-wrap"
            >
              {{ (searchedRecipients | removeEmptyContacts)?.length }}
            </span>
          </div>
        </div>
      </a>
      <ng-template ngbNavContent>
        <div class="send-sms-phonebook tw-w-full !tw-min-h-[400px]">
          <phonebook-advance-search
            [isShowInputs]="isShowInputs"
            [isShowParentName]="true"
            [privateNumber]="privateNumber"
            [isFixedHeight]="true"
            (phonebookRecipientsChange)="getSearchedRecipients($event)"
            (selectedPhonebooksChange)="getSearchedPhonebookIds($event)"
          ></phonebook-advance-search>
        </div>
      </ng-template>
    </ng-container>
  </nav>
  <div [ngbNavOutlet]="nav" class="tw-mt-2"></div>

  <!-- *global-index -->
  <phonebook-global-index
    *ngIf="isShowGlobalIndex"
    class="w-full align-self-end tw-border-t pt-2 mt-2"
    (globalIndexChange)="emitGlobalIndex($event)"
    (isValid)="isValidGlobalIndex = $event"
  >
  </phonebook-global-index>
</section>
